export default __webpack_public_path__ + "static/media/imgRocks.f42d811d.png";